import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileText, MessageSquare, CalendarCheck, Lock } from 'lucide-react';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
export function OrangTua() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Permintaan konsultasi berhasil dikirim. Guru BK akan segera menghubungi Anda untuk konfirmasi jadwal.');
      (e.target as HTMLFormElement).reset();
    }, 1000);
  };
  return <div className="min-h-screen bg-white py-12" data-id="element-410">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-411">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-412">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-413">
            <h1 className="text-4xl font-bold text-dark mb-6" data-id="element-414">
              Layanan Orang Tua
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-415">
              Kolaborasi antara sekolah dan orang tua adalah kunci keberhasilan
              peserta didik. Kami menyediakan layanan khusus untuk memfasilitasi
              komunikasi dan pemantauan perkembangan anak Anda.
            </p>
          </motion.div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-416">
          {/* Rapor Perkembangan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.1
        }} className="space-y-8" data-id="element-417">
            <div className="bg-pastel-blue-light/30 rounded-3xl p-8 border border-pastel-blue-light" data-id="element-418">
              <div className="flex items-center gap-4 mb-6" data-id="element-419">
                <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center shadow-sm" data-id="element-420">
                  <FileText className="text-blue-600 w-7 h-7" data-id="element-421" />
                </div>
                <h2 className="text-2xl font-bold text-dark" data-id="element-422">
                  Rapor Perkembangan Anak
                </h2>
              </div>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-423">
                Pantau perkembangan akademik, sosial, dan emosional anak Anda
                melalui catatan berkala dari Guru BK. Data ini bersifat rahasia
                dan hanya dapat diakses oleh orang tua/wali yang bersangkutan.
              </p>

              <div className="bg-white rounded-2xl p-6 border border-pastel-grey flex flex-col items-center justify-center text-center py-12" data-id="element-424">
                <Lock className="text-gray-400 w-12 h-12 mb-4" data-id="element-425" />
                <h3 className="text-lg font-semibold text-dark mb-2" data-id="element-426">
                  Akses Terbatas
                </h3>
                <p className="text-sm text-gray-500 mb-6 max-w-xs" data-id="element-427">
                  Hubungi Wali Kelas atau Guru BK untuk mendapatkan kode akses
                  rapor perkembangan anak Anda.
                </p>
                <Button variant="outline" data-id="element-428">Masukkan Kode Akses</Button>
              </div>
            </div>
          </motion.div>

          {/* Form Konsultasi */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-429">
            <div className="bg-white rounded-3xl p-8 border border-pastel-grey shadow-apple" data-id="element-430">
              <div className="flex items-center gap-4 mb-8" data-id="element-431">
                <div className="w-14 h-14 rounded-2xl bg-pastel-pink-light flex items-center justify-center" data-id="element-432">
                  <MessageSquare className="text-pink-600 w-7 h-7" data-id="element-433" />
                </div>
                <div data-id="element-434">
                  <h2 className="text-2xl font-bold text-dark" data-id="element-435">
                    Konsultasi Orang Tua
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-436">
                    Jadwalkan pertemuan dengan Guru BK
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-437">
                <Input label="Nama Orang Tua / Wali" required placeholder="Masukkan nama lengkap Anda" data-id="element-438" />

                <div className="grid grid-cols-2 gap-4" data-id="element-439">
                  <Input label="Nama Anak" required placeholder="Nama lengkap anak" data-id="element-440" />
                  <Input label="Kelas Anak" required placeholder="Contoh: X IPA 1" data-id="element-441" />
                </div>

                <Input label="No. HP / WhatsApp" type="tel" required placeholder="08..." data-id="element-442" />

                <Input label="Topik Konsultasi" as="select" required options={[{
                label: 'Perkembangan Akademik',
                value: 'akademik'
              }, {
                label: 'Perilaku & Sosial',
                value: 'sosial'
              }, {
                label: 'Perencanaan Karier/Kuliah',
                value: 'karier'
              }, {
                label: 'Kesehatan Mental Anak',
                value: 'mental'
              }, {
                label: 'Lainnya',
                value: 'lainnya'
              }]} data-id="element-443" />

                <Input label="Pesan Tambahan (Opsional)" as="textarea" placeholder="Ceritakan secara singkat hal yang ingin didiskusikan..." data-id="element-444" />

                <Input label="Rencana Jadwal Konsultasi" type="datetime-local" required data-id="element-445" />

                <div className="pt-4" data-id="element-446">
                  <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} data-id="element-447">
                    <CalendarCheck size={20} className="mr-2" data-id="element-448" /> Ajukan Jadwal
                    Konsultasi
                  </Button>
                </div>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}